import { create } from 'zustand';
// import { User } from './../../src/features/desktop/components/Floor/FloorMap/Data'
import { User } from '../model/types';
import {
  users,
  AvailableUsers,
  AwayUsers,
  LockedUsers,
  greenUSers,
  purpleUsers,
  infoUsers,
  redUsers,
} from '../data/userData';

interface UserI {
  roomId: number;
  users: Array<User>;
  agents: [];
  userId: string;
  preferences: any;
  moveUser: (fromRoom: number, toRoom: number) => void;
  getavailableUser: () => { name: string }[];
  getawayUser: () => { name: string }[];
  getlockedUser: () => { name: string }[];
  getgreenUsers: () => { name: string }[];
  getpurpleUsers: () => { name: string }[];
  getinfoUsers: () => { name: string }[];
  getredUsers: () => { name: string }[];
  setAgents: (agent: any) => void;
  count: number;
  incrementCount: () => void;
  lastUsedCount: number;
  setLastUsedCount: (value: number) => void;
  setPreferences: (preferences: any) => void;
}

export const UserStore = create<UserI>((set) => ({
  roomId: 30153,
  userId: '1',
  users: users,
  agents: [],
  count: 1,
  preferences: {},
  incrementCount: () => {
    set((state) => ({ count: state.count < 8 ? state.count + 1 : 1 }));
  },
  lastUsedCount: 1,
  setLastUsedCount: (value) => set({ lastUsedCount: value }),

  moveUser: (fromRoom, toRoom) =>
    set((state) => {
      const currentUser = state.users.find((e) => e.uuid == state.userId);
      console.log(currentUser);

      if (currentUser) {
        currentUser.TenantRoomId = toRoom;
      }
      return state;
    }),
  setAgents: (agents: any) => {
    set({ agents: agents });
  },
  setPreferences: (preferences: any) => {
    set({ preferences: preferences });
  },

  getavailableUser: () => AvailableUsers,
  getawayUser: () => AwayUsers,
  getlockedUser: () => LockedUsers,

  getgreenUsers: () => greenUSers,
  getpurpleUsers: () => purpleUsers,
  getinfoUsers: () => infoUsers,
  getredUsers: () => redUsers,
}));
